import styled from '@emotion/styled';

const DropDownTemplate: React.FC<any> = ({ label, children, className }) => {
  return (
    <DropDownContainer>
      <DropDownLabel>{label}</DropDownLabel>
      <DropDownContentWrapper className={`dropDownContent ${className}`}>
        {children}
      </DropDownContentWrapper>
    </DropDownContainer>
  );
};

export const HoverDropDown: React.FC<IDropDown> = ({
  children,
  label,
  className,
}) => {
  return (
    <DropDownTemplate label={label} className={className}>
      {children}
    </DropDownTemplate>
  );
};

// === interfaces
interface IDropDown {
  children: React.ReactNode;
  label: any;
  className?: string;
}

const DropDownContainer = styled.div`
  position: relative;
  cursor: pointer;
  /* border: 2px solid red; */

  &:hover > div.dropDownContent {
    opacity: 1;
    pointer-events: auto;
    /* border: 1px solid green; */
  }
`;

const DropDownLabel = styled.div`
  display: flex;
  align-items: center;
`;

const DropDownContentWrapper = styled.div`
  position: absolute;
  border: 1px solid ${({ theme }) => theme.palette.brandGrey};
  width: fit-content;
  border-radius: 0.4rem;
  /* padding: 0.75rem 0rem; */
  background-color: white;
  box-shadow: 0px 8px 16px -2px rgba(46, 58, 158, 0.05),
    0px 7px 19px -2px rgba(46, 58, 158, 0.11),
    0px 0px 1px 0px rgba(46, 58, 158, 0.25);
  overflow: hidden;
  right: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
  z-index: 5;

  &.options {
    top: -1.3rem;
    /* width: 400px; */
    /* bottom: 0rem; */
  }
`;
